<template>
  <div id="app">
    <appHeader v-if="this.$route.name !== 'login'" />
    <router-view />
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
import Header from "./components/shared/Header";
export default {
  components: {
    appHeader: Header,
  },
};
</script>

<style lang="scss">
@import "./assets/snotify/material.css";

:root {
  --color-secondary: #942b10;
  --color-main: #8d3506;
  --color-main-lighter: #a7430e;
  --color-success: #479538;
  --color-warning: #e5a50a;
  --color-danger: #bd1015;
  --color-danger-medium: #fff5f3;
  --color-danger-border: #d8a7a3;
  --color-page-bg: #f5f3ef;
  --color-surface: #fff;
  --color-surface-hover: #fbf7ef;
  --color-border: #d8d2bd;
  --color-border-strong: #b9987e;
  --color-divider: #eee9df;
  --color-text: #291003;
  --color-text-muted: #66564d;
  --color-text-subtle: #7a6a60;
  --color-on-main: #fff;
  --color-report-bg: #f3f7ff;
  --color-report-bg-hover: #eaf2ff;
  --color-report-border: #c6d5e5;
  --color-report-accent: #2975c9;
  --color-report-text: #4d6177;
  --color-input-bg: #fff;
  --color-input-border: #d8d2bd;
  --gap: 5px;
  --transition-speed: 0.3s;
  --transition-speed--slow: 0.5s;
  --transition-type: ease-out;
  --transition: all var(--transition-speed) var(--transition-type);
  --transition--slow: all var(--transition-speed--slow) var(--transition-type);
}

@font-face {
  font-family: "Google Sans";
  src: url("./assets/fonts/GoogleSans-Regular.woff2") format("woff2"),
    url("./assets/fonts/GoogleSans-Regular.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Google Sans";
  src: url("./assets/fonts/GoogleSans-Bold.woff2") format("woff2"),
    url("./assets/fonts/GoogleSans-Bold.woff") format("woff");
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: "Google Sans";
  src: url("./assets/fonts/GoogleSans-MediumItalic.woff2") format("woff2"),
    url("./assets/fonts/GoogleSans-MediumItalic.woff") format("woff");
  font-weight: 500;
  font-style: italic;
}
@font-face {
  font-family: "Google Sans";
  src: url("./assets/fonts/GoogleSans-Italic.woff2") format("woff2"),
    url("./assets/fonts/GoogleSans-Italic.woff") format("woff");
  font-weight: normal;
  font-style: italic;
}
@font-face {
  font-family: "Google Sans";
  src: url("./assets/fonts/GoogleSans-Medium.woff2") format("woff2"),
    url("./assets/fonts/GoogleSans-Medium.woff") format("woff");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Google Sans";
  src: url("./assets/fonts/GoogleSans-BoldItalic.woff2") format("woff2"),
    url("./assets/fonts/GoogleSans-BoldItalic.woff") format("woff");
  font-weight: bold;
  font-style: italic;
}
/* Generated by Glyphter (http://www.glyphter.com) on  Mon Nov 12 2018*/
@font-face {
  font-family: "sienit";
  src: url("./assets/fonts/sienit.eot");
  src: url("./assets/fonts/sienit.eot?#iefix") format("embedded-opentype"),
    url("./assets/fonts/sienit.woff") format("woff"),
    url("./assets/fonts/sienit.ttf") format("truetype"),
    url("./assets/fonts/sienit.svg#sienit") format("svg");
  font-weight: normal;
  font-style: normal;
}
[class*="icon-"]:before {
  display: inline-block;
  font-family: "sienit";
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-pass:before {
  content: "\0041";
}
.icon-user:before {
  content: "\0042";
}
.icon-charts:before {
  content: "\0043";
}
.icon-date:before {
  content: "\0044";
}
.icon-excel:before {
  content: "\0045";
}
.icon-exit:before {
  content: "\0046";
}
.icon-materials:before {
  content: "\0047";
}
.icon-new:before {
  content: "\0048";
}
.icon-options:before {
  content: "\0049";
}
.icon-overtime:before {
  content: "\004a";
}
.icon-down:before {
  content: "\004b";
}
.icon-plus:before {
  content: "\004c";
}
.icon-right:before {
  content: "\004d";
}
.icon-search:before {
  content: "\004e";
}
.icon-services:before {
  content: "\004f";
}
.icon-settings:before {
  content: "\0050";
}
.icon-spravka:before {
  content: "\0051";
}
.icon-tme:before {
  content: "\0052";
}
.icon-units:before {
  content: "\0053";
}
.icon-add_mtr:before {
  content: "\0054";
}
.icon-add_src:before {
  content: "\0055";
}
.icon-add_user:before {
  content: "\0056";
}
.icon-all:before {
  content: "\0057";
}
.icon-none:before {
  content: "\0058";
}
.icon-save:before {
  content: "\0059";
}
.icon-list:before {
  content: "\005a";
}
.icon-projects:before {
  content: "\0061";
}
.icon-delete:before {
  content: "\0062";
}
.icon-edit:before {
  content: "\0063";
}
.icon-view:before {
  content: "\0064";
}
.icon-back:before {
  content: "\0065";
}
.icon-up:before {
  content: "\0066";
}
.sienit {
  font-family: "sienit";
}
/* SIENIT 2 */
/* Generated by Glyphter (http://www.glyphter.com) on  Thu Jan 17 2019*/
@font-face {
  font-family: "sienit2";
  src: url("./assets/fonts/sienit2.eot");
  src: url("./assets/fonts/sienit2.eot?#iefix") format("embedded-opentype"),
    url("./assets/fonts/sienit2.woff") format("woff"),
    url("./assets/fonts/sienit2.ttf") format("truetype"),
    url("./assets/fonts/sienit2.svg#sienit2") format("svg");
  font-weight: normal;
  font-style: normal;
}
[class*="icon-"]:before {
  display: inline-block;
  font-family: "sienit2";
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.icon-inquiry:before {
  content: "\0041";
}
.icon-reports:before {
  content: "\0042";
}
.icon-companies:before {
  content: "\0043";
}
.icon-users:before {
  content: "\0044";
}
.icon-log:before {
  content: "\0045";
}
.icon-calendar:before {
  content: "\0046";
}
.icon-personalAgenda:before {
  content: "\0047";
}
.icon-publicAgenda:before {
  content: "\0048";
}
.icon-addObject:before {
  content: "\0049";
}
.icon-crown:before {
  content: "\004a";
}
.icon-left:before {
  content: "\004b";
}
.icon-right:before {
  content: "\004c";
}
.icon-copy:before {
  content: "\004d";
}
.icon-move:before {
  content: "\004e";
}
.icon-paste:before {
  content: "\004f";
}
.icon-company:before {
  content: "\0050";
}
.icon-worker:before {
  content: "\0051";
}
.icon-month:before {
  content: "\0052";
}
.icon-week:before {
  content: "\0053";
}
.icon-day:before {
  content: "\0054";
}
.icon-1y:before {
  content: "\0055";
}
.icon-6m:before {
  content: "\0056";
}
.icon-at:before {
  content: "\0057";
}
.icon-cm:before {
  content: "\0058";
}
.icon-mech:before {
  content: "\0059";
}
.icon-pm:before {
  content: "\005a";
}
.icon-prices:before {
  content: "\0061";
}
.icon-today:before {
  content: "\0062";
}
.icon-yesterday:before {
  content: "\0063";
}
.icon-current:before {
  content: "\0064";
}
.icon-previous:before {
  content: "\0065";
}
.icon-approved:before {
  content: "\0066";
}
.icon-ok:before {
  content: "\0067";
}
.icon-no:before {
  content: "\0068";
}
.icon-waiting:before {
  content: "\0069";
}
.icon-vacation:before {
  content: "\006a";
}
.icon-doc:before {
  content: "\006b";
}
.icon-wait:before {
  content: "\006c";
}
.icon-print:before {
  content: "\006d";
}
.icon-log:before {
  content: "\006e";
}
.sienit2 {
  font-family: "sienit2";
}
html {
  font-size: 13px;
}
body {
  background-color: #fff;
}
* {
  margin: 0;
  outline: 0;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  padding: 0;
}
#app {
  font-family: "Google Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
h2 {
  color: #373737;
  font-size: 20px;
  font-weight: 400;
}
ul {
  list-style: none;
  padding: 0;
}
li {
  display: inline;
}
a {
  cursor: pointer;
  text-decoration: none;
}
/* INPUTS */
input,
select {
  height: 40px;
  padding: 5px 15px;
  width: 100%;
}
.input-label {
  color: #373737;
  font-weight: 700;
  display: inline-block;
  margin: 5px 0;
}
.input-wrapper {
  position: relative;
  border: 1px solid #d8d2bd;
  border-radius: 4px;
  overflow: hidden;

  &.input-wrapper--icon {
    input,
    select {
      padding: 5px 15px 5px 34px;
    }
  }
}
.input-wrapper .sienit,
.input-wrapper .sienit2 {
  color: #8d3506;
  font-size: 16px;
  left: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.3s;

  &.sienit__arrow {
    left: initial;
    right: 10px;

    &.sienit__arrow--open {
      transform: scale(-1) translateY(50%);
    }
  }
}
.input-wrapper input,
.input-wrapper select {
  background-color: #fff;
  border-radius: 4px;
  border: none;
  padding: 5px 15px 5px 15px;
}
.input-wrapper select {
  padding-right: 34px;
}
/* The checkbox-wrapper */
.checkbox-wrapper {
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  height: 20px;
  margin: 10px;
  position: relative;
  padding-left: 30px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.checkbox-wrapper--disabled {
  opacity: 0.5;
}
/* Hide the browser's default checkbox */
.checkbox-wrapper input {
  cursor: pointer;
  height: 0;
  opacity: 0;
  position: absolute;
  width: 0;
}
/* Create a custom checkbox */
.checkmark {
  background-color: #d9d9d9;
  border-radius: 4px;
  height: 20px;
  left: 0;
  position: absolute;
  top: 0;
  width: 20px;
}
/* On mouse-over, add a grey background color */
.checkbox-wrapper:hover input ~ .checkmark {
  background-color: #ccc;
}
/* When the checkbox is checked, add a blue background */
.checkbox-wrapper input:checked ~ .checkmark {
  background-color: #8d3506;
}
/* When the checkbox is checked, add a red background on top */
.checkbox-wrapper input:checked ~ .checkmark-red {
  background-color: #bf392a;
}
/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  display: none;
  position: absolute;
}
/* Show the checkmark when checked */
.checkbox-wrapper input:checked ~ .checkmark:after {
  display: block;
}
/* Style the checkmark/indicator */
.checkbox-wrapper .checkmark:after {
  border: solid #fff;
  border-width: 0 2px 2px 0;
  height: 10px;
  left: 7px;
  top: 2px;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
  width: 5px;
}
.strong {
  font-weight: 700;
}
.normal {
  font-weight: 400;
}
/* SWITCH */
.switch-container {
  align-items: center;
  display: flex;
}
.switch-container > span {
  cursor: pointer;
}
.switch {
  display: inline-block;
  height: 24px;
  margin: 0 10px 0 0;
  position: relative;
  width: 48px;
}
.switch input {
  display: none;
}
.slider {
  background-color: #9f0510;
  border-radius: 34px;
  bottom: 0;
  cursor: pointer;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: 0.4s;
  -webkit-transition: 0.4s;
  -moz-transition: 0.4s;
  -ms-transition: 0.4s;
  -o-transition: 0.4s;
}
.slider:before {
  background-color: white;
  border-radius: 50%;
  bottom: 4px;
  content: "";
  height: 16px;
  left: 4px;
  position: absolute;
  transition: 0.4s;
  -webkit-transition: 0.4s;
  -moz-transition: 0.4s;
  -ms-transition: 0.4s;
  -o-transition: 0.4s;
  width: 16px;
}
input:checked + .slider {
  background-color: #3b86ff;
}
input:focus + .slider {
  box-shadow: 0 0 1px #dedede;
}
input:checked + .slider:before {
  -webkit-transform: translateX(23px);
  -ms-transform: translateX(23px);
  transform: translateX(23px);
}
.switch-selected {
  text-decoration: underline;
}
.input-hide {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
/* BUTTONS */
.btns {
  display: flex;
}
button {
  height: 40px;
  width: 100%;
}
.btn {
  align-items: center;
  border-radius: 4px;
  border: none;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 13px;
  height: 36px;
  justify-content: center;
  margin-left: 10px;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
  width: 160px;
}
.btn .sienit,
.btn .sienit2 {
  font-size: 16px;
  margin-right: 6px;
}
.btn-new {
  background-color: #8d3506;
}
.btn-new:hover {
  background-color: #a7430e;
}
.btn-reset {
  background-color: #c80d0d;
}
.btn-reset:hover {
  background-color: #dd2c2c;
}
.btn-excel {
  background-color: #217346;
}
.btn-excel:hover {
  background-color: rgb(65, 144, 101);
}
.btn-close {
  background-color: #d8d2bd;
  color: #291003;
}
.btn-close:hover {
  background-color: #d1c59e;
}
.btn-print {
  background-color: #d8edec;
  color: #000;
}
.btn-print:hover {
  background-color: #d3ebef;
}
.btn-select {
  background-color: #ece9d8;
  color: #000;
  height: 30px;
  padding: 0 15px;
  width: initial;
}
.btn-select:hover {
  background-color: #d8d2bd;
}
.btn-delete {
  background-color: #c42530;
  color: #ffffff;
}
.btn-delete:hover {
  background-color: #e03d48;
  color: #ffffff;
}
/* SELECTS */
.select {
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+IDxnPiAgPHRpdGxlPmJhY2tncm91bmQ8L3RpdGxlPiAgPHJlY3QgZmlsbD0ibm9uZSIgaWQ9ImNhbnZhc19iYWNrZ3JvdW5kIiBoZWlnaHQ9IjQwMiIgd2lkdGg9IjU4MiIgeT0iLTEiIHg9Ii0xIi8+IDwvZz4gPGc+ICA8dGl0bGU+TGF5ZXIgMTwvdGl0bGU+ICA8cmVjdCBpZD0ic3ZnXzEiIHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCIgZmlsbD0ibm9uZSIvPiAgPHBvbHlnb24gZmlsbD0iIzhkMzUwNiIgaWQ9InN2Z18yIiBwb2ludHM9IjQ3LjI1LDE1IDQ1LjE2NCwxMi45MTQgMjUsMzMuMDc4IDQuODM2LDEyLjkxNCAyLjc1LDE1IDI1LDM3LjI1ICIvPiA8L2c+PC9zdmc+);
  background-repeat: no-repeat;
  background-position: right 10px top 50%;
  background-size: 16px;
  background-color: #fff;
  border: 1px solid #d8d2bd;
  border-radius: 4px;
  cursor: pointer;
  padding: 0px 35px;
  width: 100%;
}
/* TABLES */
.table {
  border-collapse: separate;
  border-spacing: 0 10px;
  width: 100%;
}
.table tr {
  height: 50px;
}
.table tr td:first-child,
.table tr th:first-child {
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
}
.table tr td:last-child,
.table tr th:last-child {
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
}
.table td {
  padding: 0 10px;
}
.table thead tr {
  background-color: #ece9d8;
}
.table thead th {
  background-color: #ece9d8;
  line-height: 12px;
  text-align: left;
  padding: 0 10px;
}
.table tbody tr {
  background-color: #fbfaf5;
  cursor: pointer;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
}
.table tbody tr td {
  border-bottom: 1px solid #d8d2bd;
  border-top: 1px solid #d8d2bd;
}
.table tbody tr td:first-child {
  border-left: 1px solid #d8d2bd;
}
.table tbody tr td:last-child {
  border-right: 1px solid #d8d2bd;
}
.table tbody .tr-invalid {
  background-color: #fff8f8;
}
.table tbody tr:hover {
  background-color: rgba(255, 255, 255, 0.7);
}
.table .center {
  text-align: center;
}
/* TAGS */
/* WORK INDICATORS */
.worktime-indicator-wrapper {
  align-items: flex-start;
  display: inline-flex;
  flex-direction: column;
  width: 90px;
}
.worktime-indicator {
  align-items: center;
  background-color: #479538;
  border-radius: 4px;
  color: #fff;
  display: inline-flex;
  font-size: 11px;
  height: 18px;
  justify-content: center;
  margin: 1px 5px 1px 0;
  width: 38px;
}
.overtime-indicator {
  background-color: #bf892a;
}
.holiday-indicator {
  background-color: #bf392a;
}
/* USER PERMISSIONS INDICATORS */
.permission-indicator {
  background-color: #f3f3f3;
  border-radius: 4px;
  color: #fff;
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  height: 24px;
  margin-right: 8px;
  vertical-align: middle;
  padding: 5px 10px;
}
.isSuperAdmin-indicator {
  align-items: center;
  background-color: #878787;
  display: inline-flex;
  font-family: "sienit2";
  padding: 5px 7px;
}
.isAdmin-indicator {
  background-color: #d48166;
}
.isReporter-indicator {
  background-color: #dfb35b;
}
.isWorker-indicator {
  background-color: #fff;
  border: 1px solid #439b1e;
  color: #439b1e;
}
.isCEO-indicator {
  background-color: #3a9173;
}
.isHR-indicator {
  background-color: #9179a5;
}
.isLeadAll-indicator {
  background-color: #03799e;
}
.isTechLead-indicator {
  background-color: #03799e;
}
.isTechLead-indicator svg {
  display: block;
  fill: #fff;
  height: auto;
  width: 15px;
}
.isAccountant-indicator {
  background-color: #15b795;
}
.isObjectManager-indicator {
  background: #fff;
  border: 1px solid #367dd9;
  color: #367dd9;
}
.isAllObjectsManager-indicator {
  background-color: #03469e;
}
.isProjectManager-indicator {
  background-color: #545e75;
}
.isAllProjectsManager-indicator {
  background-color: #320e3b;
}
.isAllProjectsReporter-indicator {
  background-color: #384e77;
}
.isAdministrativeStaff-indicator {
  background-color: #fff;
  border: 1px solid #d48166;
  color: #d48166;
}
.isStaff-indicator {
  background-color: #fff;
  border: 1px solid #555555;
  color: #555555;
}
/* NEW REPORT/PROJECT */
.new-wrapper {
  align-items: center;
  border: 1px solid #d8d2bd;
  background-color: #fbfaf5;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  padding: 10px;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
  width: 100%;
}
.new-wrapper-inactive {
  background-color: #fff8f8;
}
.new-content {
  width: 80%;
}
/* NEW INPUTS ROW */
.new-content-inputs {
  display: flex;
  width: 100%;
}
/* NEW INPUTS */
.new-input-wrapper {
  position: relative;
  margin-right: 20px;
  width: 25%;
}
.new-content-inputs-bigger {
  border-top: 1px solid #afafaf;
  margin-top: 5px;
  padding-top: 10px;
}
.new-content-inputs-bigger .new-input-wrapper {
  width: 33.33%;
}
.new-content-inputs .new-input-wrapper:last-child,
.last-input {
  margin-right: 0;
}
.new-input-wrapper label {
  color: #373737;
  font-size: 11px;
  font-weight: 700;
}
.new-input {
  background-color: #fff;
  border-radius: 4px;
  margin: 10px 0;
  position: relative;
}
.new-input .sienit,
.new-input .sienit2 {
  color: #8d3506;
  font-size: 16px;
  left: 14px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.input-wrap .clear,
.input-wrap .disabled,
.input-wrap .edit,
.new-input .disabled,
.new-input .clear,
.new-input .edit,
.reports-tab .disabled,
.input-wrapper .disabled {
  align-items: center;
  background-color: #ffe0b2;
  border-radius: 50%;
  /* color: #fff; */
  display: flex;
  font-family: "sienit";
  font-size: 9px;
  height: 16px;
  justify-content: center;
  right: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
}
.input-wrap .clear,
.new-input .clear {
  background-color: #a7430e;
  color: #fff;
  cursor: pointer;
  font-size: 6px;
  font-weight: 700;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
}
.input-wrap .edit,
.new-input .edit {
  background-color: #a7430e;
  color: #fff;
  cursor: pointer;
  font-size: 8px;
  font-weight: 700;
  right: 30px;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
}
.new-input .clear:hover,
.new-input .edit:hover {
  opacity: 0.9;
}
.new-input input {
  background-color: #fff;
  border: 1px solid #d8d2bd;
  border-radius: 4px;
  padding: 5px 35px 5px 40px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.new-input-disabled input {
  padding-right: 30px;
}
.new-input input:focus {
  border: 1px solid #ece9d8;
  background-color: #fff;
}
.new-input-dropdown {
  background-color: #fff;
  border-radius: 4px;
  border: 0px solid #f4f4f4;
  height: 0;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 100%;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  padding: 0;
  width: 100%;
  z-index: 1;
}
.new-input-dropdown ul li {
  cursor: pointer;
  display: block;
  padding: 5px 14px;
}
.new-input-dropdown .divider-item {
  pointer-events: none;
}
.new-input-dropdown ul li:hover {
  background-color: #f9f9f9;
}
.new-input-dropdown-active,
.datepicker-dropdown-active {
  border: 1px solid #ece9d8;
  height: 25vh;
  overflow: auto;
}
.datepicker-dropdown {
  height: initial;
  transform: scaleY(0);
  transform-origin: top;
}
.datepicker-dropdown-active {
  transform: scaleY(1);
  height: initial;
}
/* NEW CONTENT DATA */
.new-content-data-row {
  border-top: 1px solid #afafaf;
  display: flex;
  margin-top: 5px;
  padding-top: 15px;
}
.new-content-data-item {
  background-color: #fff;
  border: 1px solid #d8d2bd;
  border-radius: 4px;
  height: initial;
  margin-right: 20px;
  width: 33.33%;
}
.new-content-data-item table {
  width: 100%;
}
.new-content-data-item:last-child {
  margin-right: 0;
}
.new-content-data-item-toggle {
  align-items: center;
  background-color: #fff;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  height: 50px;
  justify-content: space-between;
  padding: 0 10px;
  position: relative;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 100%;

  p {
    flex-basis: 50%;
  }
}
.new-content-data-item-toggle-circle {
  align-items: center;
  background-color: #8d3506;
  border-radius: 50%;
  color: #fff;
  font-size: 16px;
  display: flex;
  height: 34px;
  justify-content: center;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 34px;
}
.new-content-data-item-toggle-circle .sienit,
.new-content-data-item-toggle-circle .sienit2 {
  align-items: center;
  border: 1px solid #8d3506;
  border-radius: 50%;
  display: flex;
  height: 30px;
  justify-content: center;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 30px;
}
.new-content-data-item-toggle:hover {
  background-color: #ece9d8;
}
.new-content-data-item-toggle:hover .new-content-data-item-toggle-circle {
  /* background-color: #5193fd; */
}
.new-content-data-item-toggle:hover .sienit,
.new-content-data-item-toggle:hover .sienit2 {
  border-color: #fff;
}
thead.new-content-data-item-toggle {
  display: table-caption;
}
.new-content-data-item-toggle .ma-cell {
  padding: 10px 20px 10px 5px;
  /* width: 66px; */
  white-space: nowrap;
}
.new-content-data-item-toggle .ma-cell {
  /* width: 50px; */
}
.new-content-data-item-toggle tr {
  display: flex;
  justify-content: space-between;
}
/* WHEN EITHER WORKERS, MATERIALS OR ACTIVITIES IS SELECTED */
.new-content-data-row-active {
  /* border-top: none; */
  flex-direction: column;
  margin-top: 15px;
}
.new-content-data-row-active .new-content-data-item-toggle {
  background-color: #ece9d8;
  height: 36px;
}
.new-content-data-row-active .new-content-data-item-toggle:hover {
  background-color: #ece9d8;
}
.new-content-data-row-active .new-content-data-item-toggle-circle {
  position: absolute;
  right: 10px;
  top: 6px;
}
.new-content-data-row-active .new-content-data-item {
  margin-bottom: 15px;
  width: 100%;
}
/* CONTENT */
.new-content-data-item-content {
  padding: 10px;
  width: 100%;
}
.new-content-data-item-content table,
.new-content-data-item-content tbody {
  width: 100%;
}
.new-content-data-item-content table td {
  height: 20px;
}
.new-content-data-item-content .users-cell {
  color: #737373;
  font-size: 11px;
  padding: 0 20px;
  width: 50%;
}
.new-content-data-item-content .users-cell p {
  display: inline-block;
  margin-right: 20px;
}
.table .td-company-name {
  position: relative;
  padding: 0 20px;
}
.table .td-invalid-flag {
  position: absolute;
  width: 14px;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
}
.new-content-data-item-content .ma-cell,
.nothing-added {
  color: #737373;
  font-size: 11px;
  padding: 0 20px;
  width: 10%;
  /* white-space: nowrap; */
}
.nothing-added {
  text-align: center;
}
.new-content-data-item-content .ma-cell-name,
.new-content-data-item-toggle .ma-cell-name {
  width: 50%;
  position: relative;
}
.ma-cell-name .sienit {
  color: #bf392a;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  position: absolute;
  left: 0px;
  opacity: 0.1;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  top: 50%;
  transform: translateY(-50%);
}
.new-content-data-item-content table tr:hover .ma-cell-name .sienit {
  opacity: 1;
}
.ma-cell-input {
  background-color: #fff;
  border: 1px solid #fff;
  border-radius: 4px;
  color: #737373;
  height: 18px;
  margin-right: 6px;
  padding: 0 2px;
  text-align: right;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 60px;
}
.ma-cell-input:focus {
  border-color: #0099ff;
}
.new-content-data-item-content-lists {
  display: flex;
  flex-wrap: wrap;
}
.new-content-data-item-content-lists > span,
.new-content-data-item-content-lists .reporters-roles > span {
  color: #737373;
  display: inline-block;
  font-size: 11px;
  padding: 5px 20px;
  width: 20%;
}
.reporters-roles {
  display: flex;
  margin: 10px;
  width: 100%;

  > span {
    flex-basis: 50%;
  }

  .reporter__actions {
    display: flex;
    justify-content: space-between;
    gap: 5px;
    flex-basis: 55%;

    .unit-dd {
      width: 220px;
    }
  }
}
/* MODAL */
.modal-wrapper {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
}
.modal {
  background-color: #fbfaf5;
  border-radius: 4px;
  max-height: 70vh;
  overflow: hidden;
  width: 60%;
}
.modal-header {
  align-items: center;
  background: #942b10; /* Old browsers */
  background-color: #942b10;
  display: flex;
  height: 70px;
  justify-content: center;
  position: relative;
}
.modal-header .new-input {
  margin: 0;
  width: 80%;
}
.modal-header .new-input input {
  border: none;
}
.modal-close {
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 50%;
  padding: 10px;
  transform: translateY(-50%);
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.modal-close:hover {
  background-color: rgba(255, 255, 255, 0.2);
}
.modal-content {
  display: flex;
  flex-wrap: wrap;
  max-height: 50vh;
  overflow: auto;
  padding: 20px;
}
.modal-footer {
  align-items: center;
  background-color: #fbfaf5;
  display: flex;
  height: 70px;
  justify-content: space-between;
  padding: 0 20px;
  width: 100%;
}
.modal-content-check {
  border-radius: 4px;
  margin: 2px;
  width: calc(33.33% - 4px);
}
.modal-content-add {
  align-items: center;
  background-color: rgba(59, 134, 255, 0.1);
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.modal-content-add .sienit {
  color: #3b86ff;
  font-size: 18px;
}
.modal-content-add:hover {
  background-color: rgba(59, 134, 255, 0.2);
}
.modal-content-item {
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  height: 40px;
  margin-bottom: 5px;
  margin-right: 20px;
  padding-right: 30px;
  padding-left: 10px;
  position: relative;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: calc(50% - 20px);
}
.modal-content-item > p {
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.modal-content-item em {
  opacity: 0.5;
}
.modal-content-item .sienit {
  align-items: center;
  cursor: pointer;
  display: flex;
  font-size: 20px;
  height: 20px;
  justify-content: center;
  opacity: 0;
  position: absolute;
  right: 10px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 20px;
}
.modal-content-item:hover {
  background-color: #ece9d8;
}
.modal-content-item:hover .sienit {
  color: #d80000;
  opacity: 0.4;
}
.modal-content-item .sienit:hover {
  opacity: 1;
}
.modal-content-template {
  cursor: pointer;
  display: flex;
  justify-content: center;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 100%;
}
.modal-content-template:hover {
  opacity: 0.8;
}
.modal-content-no-results {
  padding: 20px 0;
  text-align: center;
  width: 100%;
}
/* DATEPICKER */
.custom-datepicker {
  margin: 0 auto !important;
  width: 100% !important;
  padding: 10px;
}
.custom-calendar {
  background-color: transparent !important;
  border: none !important;
  width: 100% !important;
}
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
  /* background-color: rgba(0, 153, 255, 0.1) !important; */
  border-color: transparent !important;
  border-radius: 4px;
}
.vdp-datepicker__calendar .cell.highlighted {
  background-color: #d9e4ec !important;
  border: 1px solid #8fa4bf !important;
  border-radius: 4px !important;
}
.vdp-datepicker .vdp-datepicker__calendar .cell.selected,
.vdp-datepicker .vdp-datepicker__calendar .cell.highlighted {
  background-color: #8d3506 !important;
  border: none !important;
  border-radius: 4px !important;
  color: #fff;
}
/* CALENDAR DATEPICKER STYLES */
.calendar-wrapper .vdp-datepicker .vdp-datepicker__calendar {
  background-color: #fff !important;
  border-radius: 4px;
  border: 1px solid #f4eaea !important;
  width: 100% !important;
}
.calendar-wrapper .vdp-datepicker__calendar header .prev,
.calendar-wrapper .vdp-datepicker__calendar header .next,
.copy-move-modal .vdp-datepicker__calendar header .prev,
.copy-move-modal .vdp-datepicker__calendar header .next {
  text-indent: initial;
  color: transparent;
}
.calendar-wrapper .vdp-datepicker .vdp-datepicker__calendar .prev::after,
.calendar-wrapper .vdp-datepicker .vdp-datepicker__calendar .next::after,
.copy-move-modal .vdp-datepicker .vdp-datepicker__calendar .prev::after,
.copy-move-modal .vdp-datepicker .vdp-datepicker__calendar .next::after {
  border: none;
  color: #000;
  content: "L";
  font-family: "sienit2";
  font-size: 12px;
  left: 50%;
  opacity: 0.5;
  position: absolute;
  top: 50%;
}
.calendar-wrapper .vdp-datepicker .vdp-datepicker__calendar .prev::after,
.copy-move-modal .vdp-datepicker .vdp-datepicker__calendar .prev::after {
  content: "K";
}
.calendar-wrapper .vdp-datepicker .vdp-datepicker__calendar .cell.selected,
.calendar-wrapper .vdp-datepicker .vdp-datepicker__calendar .cell.highlighted,
.copy-move-modal .vdp-datepicker .vdp-datepicker__calendar .cell.selected {
  background-color: transparent !important;
  border-radius: 50% !important;
  color: #fff !important;
  position: relative;
  z-index: 1;
}
.calendar-wrapper .vdp-datepicker .vdp-datepicker__calendar .cell.highlighted {
  border: none !important;
}
.calendar-wrapper .vdp-datepicker .vdp-datepicker__calendar .cell.day,
.copy-move-modal .vdp-datepicker .vdp-datepicker__calendar .cell.day {
  position: relative;
}
.calendar-wrapper .vdp-datepicker .vdp-datepicker__calendar .cell.day::before,
.copy-move-modal .vdp-datepicker .vdp-datepicker__calendar .cell.day::before {
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.calendar-wrapper
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.day:hover::before,
.copy-move-modal
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.day:hover::before {
  background-color: rgba(141, 53, 6, 0.1);
  box-sizing: border-box;
  border-radius: 50%;
  content: "";
  height: 34px;
  left: 50%;
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 34px;
}
.calendar-wrapper
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.selected::before,
.calendar-wrapper
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.highlighted::before,
.copy-move-modal
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.selected::before {
  background-color: #8d3506;
  box-sizing: border-box;
  border-radius: 50%;
  content: "";
  height: 34px;
  left: 50%;
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 34px;
  z-index: -1;
}
.calendar-wrapper
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.selected::after,
.calendar-wrapper
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.highlighted::after,
.copy-move-modal
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.selected::after {
  box-sizing: border-box;
  border-radius: 50%;
  border: 1px solid #8d3506;
  content: "";
  height: 30px;
  left: 50%;
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 30px;
  z-index: -1;
}
.calendar-wrapper
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.selected:hover::before,
.calendar-wrapper
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.highlighted:hover::before,
.copy-move-modal
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.selected:hover::before {
  background-color: #8d3506 !important;
}
.calendar-wrapper
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.selected:hover::after,
.calendar-wrapper
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.highlighted:hover::after,
.copy-move-modal
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.selected:hover::after {
  background-color: #8d3506 !important;
  border: 1px solid #fff !important;
}
.vdp-datepicker__calendar .today {
  font-weight: 700 !important;
}
/* HIGHLIGHTED EXISTING DAYS */
.calendar-wrapper
  .left-panel-day-mode
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.highlighted:not(.selected)::before {
  background-color: rgba(255, 119, 0, 0.2);
  height: 32px !important;
  width: 32px !important;
}
.calendar-wrapper
  .left-panel-day-mode
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.highlighted:not(.selected)::after {
  border: 1px solid transparent;
}
.calendar-wrapper
  .left-panel-day-mode
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.highlighted:not(.selected) {
  color: #000 !important;
}
.calendar-wrapper
  .left-panel-day-mode
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.highlighted:not(.selected):hover::before {
  background-color: rgba(141, 53, 6, 0.1) !important;
  height: 34px !important;
  width: 34px !important;
}
.calendar-wrapper
  .left-panel-day-mode
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.highlighted:not(.selected):hover::after {
  background-color: rgba(141, 53, 6, 0.1) !important;
  border: 1px solid transparent !important;
}
/* CALENDAR WEEK MODE  */
.calendar-wrapper
  .left-panel-week-mode
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.highlighted::after {
  border: none;
  opacity: 0;
}
.calendar-wrapper
  .left-panel-week-mode
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.highlighted::before {
  border-radius: 0;
  /* height: 100%; */
  width: 110%;
}
.calendar-wrapper
  .left-panel-week-mode
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.highlight-start::before {
  border-top-left-radius: 30px !important;
  border-bottom-left-radius: 30px !important;
  left: initial;
  right: 0;
  transform: translateY(-50%);
  width: 90%;
}
.calendar-wrapper
  .left-panel-week-mode
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.highlight-end::before {
  border-top-right-radius: 30px !important;
  border-bottom-right-radius: 30px !important;
  left: 0;
  transform: translateY(-50%);
  width: 90%;
}
.calendar-wrapper
  .left-panel-week-mode
  .vdp-datepicker
  .vdp-datepicker__calendar
  .cell.highlighted:hover::before {
  background-color: #8d3506 !important;
}
/* COPY-MOVE MODAL */
.copy-move-modal .vdp-datepicker__calendar {
  border: none !important;
}
.copy-move-modal .vdp-datepicker__calendar header .prev:after {
  margin: 0 !important;
}
.copy-move-modal .vdp-datepicker__calendar header .next:after {
  margin: 0 !important;
}
.loading-container {
  align-items: center;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}
.loading {
  width: 50px;
}
.no-wrap {
  white-space: nowrap;
}
/* TRANSITIONS */
.fade-enter-active,
.fade-leave-active {
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.slide-enter-active,
.slide-leave-active {
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(-25%);
}
.slideFromRight-enter-active,
.slideFromRight-leave-active {
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.slideFromRight-enter, .slideFromRight-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  position: absolute;
  transform: translateX(100%);
}
.slide-right-and-fade-enter-active,
.slide-right-and-fade-leave-active {
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.slide-right-and-fade-enter  /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  position: absolute;
  transform: translateX(100%);
}

.slide-right-and-fade-leave-to {
  opacity: 0;
}
/* .desktop{
  display:inherit;
}
.mobile{
  display: none;
} */
.text-align-center {
  text-align: center;
  width: 100%;
}

.flag-indicator {
  height: 24px;
  width: 30px;
}

.stop-scrolling {
  overflow: hidden;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

@media screen and (max-width: 1000px) {
  .mobile-datepicker-wrapper .vdp-datepicker .vdp-datepicker__calendar {
    background-color: #fff !important;
    border-radius: 4px;
    width: 100%;
  }
}
</style>
